import React, { useState } from "react";
import { useParams } from "react-router-dom";
import projects from "./ProjectData";

function ProjectDetail() {
  const { id } = useParams();
  const project = projects.find((item) => item.id === parseInt(id));

  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: ""
  });

  if (!project) return <h2>Project Not Found</h2>;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone) {
      alert("Fill all details");
      return;
    }

    setSubmitted(true);
  };

  return (
    <div style={{ padding: "50px" }}>

      <h1>{project.title}</h1>
      <p>{project.location}</p>

      <img
        src={project.image}
        style={{ width: "100%", marginBottom: "30px" }}
        alt=""
      />

      <h3>About</h3>
      <p>{project.description}</p>

      <h3>Highlights</h3>
      <ul>
        {project.highlights.map((h, i) => (
          <li key={i}>{h}</li>
        ))}
      </ul>

      {/*  GALLERY */}
      <h3>Gallery</h3>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2,1fr)",
        gap: "10px"
      }}>
        {project.gallery.map((img, i) => (
          <img
            key={i}
            src={img}
            alt=""
            style={{
              width: "100%",
              borderRadius: "10px",
              transition: "0.3s"
            }}
          />
        ))}
      </div>

      {/* RIGHT SIDE */}
      <div style={{ marginTop: "40px" }}>

        <h4>Route Map</h4>
        <img src={project.layout} style={{ width: "100%" }} alt="" />

        <h4>Location</h4>
        <iframe src={project.map} width="100%" height="200"></iframe>

        <button onClick={() => setShowForm(!showForm)}>
          Book Site Visit
        </button>

        {showForm && !submitted && (
          <form onSubmit={handleSubmit}>
            <input
              placeholder="Name"
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
            <input
              placeholder="Phone"
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
            />
            <button type="submit">Submit</button>
          </form>
        )}

        {submitted && <p>✅ Submitted Successfully</p>}

      </div>

    </div>
  );
}

export default ProjectDetail;